module.exports = __webpack_public_path__ + "img/thunderboar_tornado.8881ac6a.png";